import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

const COOKIE_CONSENT_KEY = 'cookie_consent';

export const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'declined');
    // Disable Google Analytics
    window['ga-disable-G-Y8MC2MR9ND'] = true;
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-card border-t border-border">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm text-foreground text-center sm:text-left">
          {t('cookies.message')}
        </p>
        <div className="flex gap-2 shrink-0">
          <Button size="sm" onClick={handleAccept}>
            {t('cookies.accept')}
          </Button>
          <Button variant="outline" size="sm" onClick={handleDecline}>
            {t('cookies.decline')}
          </Button>
        </div>
      </div>
    </div>
  );
};
